<div>
    <h5>Bijlages</h5>
</div>

<table
    class="table table-hover table-center"
    [class.table-add-row]="!fieldFormData.form.disabled"
    [class.table-last-col]="!fieldFormData.form.disabled">
    <tr>
        <th class="icon-col"></th>
        <th>Bestand</th>
        <th>Toegevoegd op</th>
        <th>Door</th>

        @if (!fieldFormData.form.disabled) {
            <th></th>
        }
    </tr>

    @if (fieldFormData?.planningFiles?.length) {
        @for (file of fieldFormData.planningFiles; track file.id ?? file.name) {
            <tr>
                <td class="icon-col">
                    <a (click)="downloadFile(file)">
                        <mat-icon fontSet="fa-regular" fontIcon="fa-file-arrow-down"></mat-icon>
                    </a>
                </td>
                <td>
                    <a (click)="openFile(file)">
                        {{ file.name }}
                    </a>
                </td>

                <td>{{ file.created_at ? (file.created_at | date: 'EEEE d MMM yyyy HH:mm') : '-' }}</td>
                <td>{{ file.user?.name ?? '-' }}</td>

                @if (!fieldFormData.form.disabled) {
                    <td>
                        <button
                            class="icon-button-medium"
                            (click)="removeFile(file)"
                            color="warn"
                            mat-icon-button
                            matTooltip="Verwijder"
                            matTooltipClass="warn-background"
                            matTooltipPosition="right"
                            tabindex="-1">
                            <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                        </button>
                    </td>
                }
            </tr>
        }
    }

    @if (Features.PlanningSaveSave | hasFeature) {
        @if (!fieldFormData.form.disabled) {
            <tr>
                <td class="pt-2" [colSpan]="4">
                    <app-codalt-upload-file
                        [fcFile]="uploadControl"
                        [fileStorage]="fileStorage"
                        [allowedTypes]="allowedTypes"
                        (submitted)="addFile($event)"
                        (onError)="onError()"
                        label="Bestanden toevoegen" />
                </td>
            </tr>
        }
    }
</table>
